module.exports = __webpack_public_path__ + "static/media/culture_mission.02921180.png";